angular.module('impactx.demand').controller('DemandListReadOnlyCtrl', [
    '$redirect',
    'dataGen',
    'selectedListItems',
    '$mdDialog',
    DemandListReadOnlyCtrl
]);

function DemandListReadOnlyCtrl($redirect, dataGen, selectedListItems, $mdDialog) {
    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'DemandView'
        },
        {
            label: "cancel",
            action: cancelItems,
            condition: canCancel,
            process: 'Cancellation'
        },
        {
            label: "cancelAll",
            action: cancelAll,
            condition: canCancel,
            process: 'Cancellation'
        }
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/status/demand/templates/demandlistreadonly.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/demand/listreadonly',
        ctrl: this,
        id: "demandlistreadonly",
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };

    function cancelItems() {
        var newScope = {};
        var selected = [];
        angular.forEach(selectedListItems.getSelectedIds(), function (id) {
            selected.push({id: id});
        });
        dataGen.getData(newScope, {selected: [selected]}, '/demand/cancellation/view').then(function (data) {
            if (data.errors.length < 1) {
                $redirect.redirectTo(null, "/canceldemand", selected);
            }
        });
    }

    function cancelAll(event) {
        var selected = [];
        angular.forEach(selectedListItems.getSelectedIds(), function (id) {
            selected.push({id: id});
        });

        $mdDialog.show({
            controller: "CancelAllDemandCtrl",
            controllerAs: "cancelAllCtrl",
            templateUrl: "modules/cancellation/templates/cancellation-all.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                selectedEntries: selected
            }
        })
    }

    function getDetailLink() {
        return "demanddetail/" + selectedListItems.getFirstSelectedId();
    }

    function canCancel() {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canCancel.value;
    }
}
